export default __webpack_public_path__ + "bbbb9e860c13936039f7cb55a2a15896.ico";